var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"weitap",staticStyle:{"width":"300px"}},_vm._l((_vm.shuju),function(da,index){return _c('li',{class:{active:index==_vm.Tapchecked},on:{"click":function($event){_vm.tapjump(da.lian)}}},[_vm._v(" "+_vm._s(da.neir))])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1204bd26","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/weitap.vue
// module id = null
// module chunks = 